export const homeFaqList = [
  {
    question: "瓜田日报的每日合集是什么时候更新？",
    answer:
      "每日合集通常在每天上午 09:00 至 11:00 之间上线，如遇话题密集的时段会临时追加一次更新。合集会把当天值得关注的爆料吃瓜话题按时间顺序整理好，方便一次看完。",
  },
  {
    question: "热门盘点和每日合集有什么区别？",
    answer:
      "每日合集按时间顺序梳理当天话题，重在「今天发生了什么」；热门盘点则按热度排序，重在「哪些话题值得重点看」。两者配合使用，可以既不漏事也能抓住重点。",
  },
  {
    question: "网站上的话题内容是怎么来的？",
    answer:
      "站内内容由编辑团队根据公开的娱乐资讯整理、归纳并做时间线梳理，同时标注话题来源性质。对于尚未被当事人回应的信息，我们会在文中明确提示「未经核实」，不做结论性判断。",
  },
  {
    question: "看到不准确的内容可以反馈吗？",
    answer:
      "可以。你可以通过联系我们页面提交留言，说明具体是哪一篇内容、哪一处表述存在问题。我们会在收到反馈后的一个工作日内核对，确有出入的内容会直接修订并标注更正说明。",
  },
  {
    question: "网站会收集我的个人信息吗？",
    answer:
      "浏览网站不需要注册，也不会强制收集个人信息。只有在主动填写联系表单时，才会记录你提交的称呼、邮箱与留言内容，这些信息仅用于回复你的问题。",
  },
  {
    question: "为什么有些话题只有速览要点，没有完整正文？",
    answer:
      "对于信息量较少、仍在发展中的话题，我们会先给出速览要点，等事件脉络更清晰后再补充完整的时间线与正文，避免用推测内容填充篇幅。",
  },
];

export const aboutFaqList = [
  {
    question: "瓜田日报的内容团队是怎么构成的？",
    answer:
      "团队由编辑、资料核对与栏目运营三部分组成。编辑负责选题与成稿，核对岗专责比对公开信息与时间线，栏目运营负责分类归档与榜单结算，三个环节相互独立。",
  },
  {
    question: "你们会主动联系当事人求证吗？",
    answer:
      "对于涉及个人评价的话题，我们会优先等待当事人或其工作团队的公开回应，并在文中同步呈现。如果暂时没有回应，我们只描述已发生的事实，不下结论。",
  },
  {
    question: "为什么有些内容会被移除或更正？",
    answer:
      "当出现新的公开信息、或当事人作出明确回应时，原内容如果与之不符，我们会直接更正或下架，并在原链接保留简短说明，避免旧的表述继续被引用。",
  },
  {
    question: "站内的热度数据代表真实人数吗？",
    answer:
      "热度是一个综合加权值，包含浏览、收藏与转发的合计，并不等同于独立访客人数。我们更希望它体现话题的相对关注度，而不是绝对流量。",
  },
  {
    question: "可以投稿或提供线索吗？",
    answer:
      "可以。通过联系我们页面留言时，请在内容中说明线索的基本情况与可核实的公开来源。我们会先做事实核查，再决定是否整理成稿。",
  },
];